import { WindowService } from 'pf-frontend-common/src/service/window/service';

import { FooterView } from 'common/module/footer/view';
import { StatsService } from 'common/service/stats/service';
import { StatsTealiumProviderService } from 'common/service/stats-tealium-provider/service';

export function FooterViewFactory(): FooterView {
  return new FooterView(StatsService(), StatsTealiumProviderService(), WindowService());
}
